import { type CreateRoundWizardProposal } from "@engine/round/actions";
import { Button } from "@sfc/ui";
import { PlusIcon, Trash2Icon } from "lucide-react";
import { type Control, type FieldValues, type Path } from "react-hook-form";
import { FormInput } from "./form-input";
import { FormTextarea } from "./form-textarea";

type CustomFields = CreateRoundWizardProposal["customFields"];

export function ProposalCustomFieldsEditor<Values extends FieldValues>({
  control,
  fields,
  onAdd,
  onRemove,
}: {
  control: Control<Values>;
  fields: CustomFields;
  onAdd: () => void;
  onRemove: (id: string) => void;
}) {
  return (
    <>
      {fields.map((field, index) => (
        <div
          key={field.id}
          className="border rounded-md p-4 flex flex-col gap-4"
        >
          <FormInput
            control={control}
            name={`customFields.${index}.title` as Path<Values>}
            label={`Custom Field ${index + 1} - Title`}
            placeholder="e.g., Contact Email"
          />
          <FormTextarea
            control={control}
            name={`customFields.${index}.description` as Path<Values>}
            label={`Custom Field ${index + 1} - Description`}
            placeholder="e.g., We will use this email to contact you."
          />
          <FormInput
            control={control}
            name={`customFields.${index}.value` as Path<Values>}
            label={`Custom Field ${index + 1} - Answer for this proposal`}
            placeholder="e.g., your.email@example.com"
          />
          <Button
            className="self-start"
            variant="destructive-quiet"
            type="button"
            onClick={() => onRemove(field.id)}
          >
            <Trash2Icon className="size-4" />
            Remove
          </Button>
        </div>
      ))}

      <Button
        className="self-start bg-background"
        variant="outline"
        type="button"
        onClick={onAdd}
      >
        <PlusIcon className="size-4" />
        Add Custom Field
      </Button>
    </>
  );
}
